var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["drop-search-result", _vm.mod, { _loader: !_vm.isSearchResult }],
    },
    [
      _c(
        "div",
        {
          staticClass: "drop-search-result__content-wrapper",
          style: "height: " + _vm.contentWrapperHeight,
        },
        [
          _c(
            "div",
            { staticClass: "drop-search-result__content" },
            [
              _vm.isSearchHints
                ? _c("clarifications-block", {
                    staticClass: "drop-search-result__hints",
                    attrs: {
                      "with-title": false,
                      "taps-list": _vm.searchHints,
                      "hide-decorator-on-mobile": true,
                    },
                    on: { setQuery: _vm.onSetQuery },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isViewHistory
                ? _c("search-history", {
                    staticClass: "drop-search-result__history",
                    attrs: { items: _vm.localStorageHistory },
                    on: {
                      clearHistory: _vm.deleteHistory,
                      setItem: _vm.onSetQuery,
                      deleteItem: _vm.deleteItem,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isSearchPopular
                ? _c("search-items-popular", {
                    staticClass: "drop-search-result__popular",
                    attrs: { items: _vm.searchPopular },
                    on: { setQuery: _vm.onSetQuery },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isSearchCategories
                ? _c("search-items-categories", {
                    staticClass: "drop-search-result__categories",
                    attrs: { items: _vm.searchCategories },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isSearchResult
                ? _c("search-items-result", {
                    staticClass: "drop-search-result__result",
                    attrs: { items: _vm.data.products },
                  })
                : _vm.hasdata
                ? _c("span", { staticClass: "no-result-text" }, [
                    _vm._v("По вашему запросу ничего не найдено"),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showAllResultsButton
        ? _c(
            "button",
            {
              staticClass: "show-more-button",
              attrs: { disabled: !_vm.searchStringIsNotEmpty },
              on: { click: _vm.showMoreButtonHandler },
            },
            [_c("span", [_vm._v("Смотреть все результаты")])]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }